import './social_content_context_view.js.coffee';# Added by Script 
Monitoring.Views ||= {}

class Monitoring.Views.SocialContentFollowingCommentsView extends Monitoring.Views.SocialContentContextView

  initialize: (@options = {}) ->
    super(@options)
    @$resultsContainer = @$el.find('#following_comments')

  noResultsMessage: ->
    'NO FOLLOWING COMMENTS FOUND'

  formatResults: ->
    amountReceived = @$resultsContainer.find('section').length
    maxAmountToShow = @searchQuery.getContextLimit()
    if amountReceived > maxAmountToShow
      @$resultsContainer.find('section:last').remove()
      @$resultsContainer.after(@moreContextLinkHtml())
    super()